import React, { lazy } from 'react';

const DocumentFolderListing = lazy(() =>
  import('./EDocListing').then(module => ({
    default: module.DocumentFolderListing,
  })),
);
const DocumentFileDetail = lazy(() =>
  import('./EDocumentFileDetail').then(module => ({
    default: module.DocumentFileDetail,
  })),
);

const digitalDocRoutes = [
  {
    props: { exact: true, path: '/digital-documents' },
    component: <DocumentFolderListing />,
  },
  {
    props: { exact: true, path: '/digital-documents/:contractID' },
    component: <DocumentFolderListing />,
  },
  {
    props: {
      exact: true,
      path: '/digital-documents/:siteID/folder/:menuID',
    },
    component: <DocumentFileDetail />,
  },
];

export default digitalDocRoutes;
